var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"container",class:this.footerClasses},[_c('p',[_vm._v("ryan.gehrlein@gmail.com")]),_c('p',[_vm._v("203-274-0985")])])}
var staticRenderFns = []

export { render, staticRenderFns }